import { FormattedMessage } from "react-intl";
import { Button } from "@letsbit/milkylb";
import jsPDF from "jspdf";
import React, { useRef, useState } from "react";
import { IonSkeletonText } from "@ionic/react";

import { InvoiceLocal } from "./components/InvoiceLocal";
import { DownloadInvoiceProps } from "./types";
import { messages } from "./messages";
import { InvoiceForeign } from "./components/InvoiceForeign";
import { INVOICE_WITHHOLDING_TYPE } from "@letsbit/malcolmlb";
import { useGetInvoice } from "hooks/withholdings/useGetInvoice";
import { ReactComponent as InfoIcon } from "assets/images/icons/info.svg";

export const DownloadInvoice: React.FC<DownloadInvoiceProps> = ({
  service,
  type,
  external_txid,
}) => {
  const [loading, setLoading] = useState(false);
  const invoiceRef = useRef<HTMLDivElement>(null);
  const { data: invoice, error } = useGetInvoice({
    service,
    type,
    external_txid,
  });

  const generatePDF = async (filename = "receipt") => {
    try {
      setLoading(true);
      const jspdf = new jsPDF("p", "px", "a4", true);

      jspdf.setFont("courier");
      if (invoiceRef.current) {
        const duplicatedConatainer = invoiceRef.current.children[0].cloneNode(
          true,
        ) as HTMLElement;
        duplicatedConatainer.classList.add("pdf");
        document.body.appendChild(duplicatedConatainer);
        // You can now access the new document's content
        await jspdf.html(duplicatedConatainer.outerHTML, {
          margin: [20, 20, 20, 20],
          autoPaging: "text",
          width: 170,
          html2canvas: { scale: 0.4 },
          callback: (doc) => doc.save(filename),
        });
        document.body.removeChild(duplicatedConatainer);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return invoice ? (
    invoice.pending ? (
      <div className="mt-4 flex items-center">
        <InfoIcon className="mr-2 h-[24px] w-[24px] shrink-0" />
        <p className="text-xs font-semibold text-[--milkylb-color-neutral-400]">
          <FormattedMessage
            {...messages.awaitningInvoice}
            values={{
              br: <br />,
            }}
          />
        </p>
      </div>
    ) : (
      <Button
        isLoading={loading}
        className="pdf:hidden"
        fill="clear"
        onClick={() => {
          generatePDF(`factura-${invoice.tid}.pdf`);
        }}
      >
        <div style={{ display: "none" }} ref={invoiceRef}>
          {invoice.type === INVOICE_WITHHOLDING_TYPE.FOREIGN ? (
            <InvoiceForeign invoice={invoice} />
          ) : (
            <InvoiceLocal invoice={invoice} />
          )}
        </div>
        <FormattedMessage {...messages.downloadButton} />
      </Button>
    )
  ) : (
    !error && (
      <div className="mt-4 flex items-center">
        <IonSkeletonText className="mr-2 h-[24px] w-[24px] rounded-full" />
        <IonSkeletonText animated className="rounded-lg" />
      </div>
    )
  );
};
